import { Box, Image, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"

import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"

import { KlarnaTitle } from "./components"

const BetterWayToPayIn3 = () => {
  const sampleAmount = 150

  return (
    <Box contain mb={7}>
      <KlarnaTitle>The Better Way To Pay</KlarnaTitle>
      <Typography mb={5} px={3} textAlign="center">
        Get the {jewlr_t("terms.jewelry")} you love now and spread the cost of
        your purchase into three
        <Box as="br" display={{ _: "none", tablet: "block" }} />
        monthly {jewlr_t("terms.instalment")}s.
      </Typography>
      <Flex alignItems="center" flexDirection={{ _: "column", tablet: "row" }}>
        <Box flex="1" mb={{ _: 4, tablet: 0 }}>
          <Image
            alt="The Better Way To Pay"
            src={require("images/info/klarna/jewlr4-better-way-to-pay.jpg")}
          />
        </Box>
        <Box flex="1" textAlign="center">
          <KlarnaTitle>Pay In 3</KlarnaTitle>
          <Typography
            mb={3}
            px={{ _: "90px", desktop: "140px" }}
            textAlign="center"
          >
            Choose Klarna and split the cost into 3 payments on orders over{" "}
            {to_currency(sl.config.klarna_min)}.
          </Typography>
          <Image
            alt="JWL0018"
            mb={1}
            src={require("images/info/klarna/jewlr4-ring.png")}
            width="260px"
          />
          <Typography as="h3" fontSize={18} mb={2}>
            Double Heart Gemstone Ring with Accents
          </Typography>
          <Flex alignItems="center" gutter={2} justifyContent="center" mb={2}>
            <Box borderRight="1px solid #979797" py={1} textAlign="right">
              <Typography fontSize={38} fontWeight="300" lineHeight="1">
                {to_currency(sampleAmount)}
              </Typography>
            </Box>

            <Typography lineHeight="25px">
              3 payments of {to_currency(sampleAmount / 3)}.
            </Typography>
          </Flex>
        </Box>
      </Flex>
    </Box>
  )
}

const BetterWayToPayIn4 = () => {
  const sampleAmount = 200

  return (
    <Box contain mb={7}>
      <KlarnaTitle>The Better Way To Pay</KlarnaTitle>
      <Typography mb={5} px={3} textAlign="center">
        Get the {jewlr_t("terms.jewelry")} you love now and spread the cost of
        your purchase into four
        <Box as="br" display={{ _: "none", tablet: "block" }} />
        biweekly {jewlr_t("terms.instalment")}s.
      </Typography>
      <Flex alignItems="center" flexDirection={{ _: "column", tablet: "row" }}>
        <Box flex="1" mb={{ _: 4, tablet: 0 }}>
          <Image
            alt="The Better Way To Pay"
            src={require("images/info/klarna/jewlr4-better-way-to-pay.jpg")}
          />
        </Box>
        <Box flex="1" textAlign="center">
          <KlarnaTitle>Pay Later in 4</KlarnaTitle>
          <Typography
            mb={3}
            px={{ _: "90px", desktop: "140px" }}
            textAlign="center"
          >
            Choose Klarna and split the cost into 4 payments on orders over{" "}
            {to_currency(sl.config.klarna_min)}.
          </Typography>
          <Image
            alt="JWL0018"
            mb={1}
            src={require("images/info/klarna/jewlr4-ring.png")}
            width="260px"
          />
          <Typography as="h3" fontSize={18} mb={2}>
            Double Heart Gemstone Ring with Accents
          </Typography>
          <Flex alignItems="center" gutter={2} justifyContent="center" mb={2}>
            <Box borderRight="1px solid #979797" py={1} textAlign="right">
              <Typography fontSize={38} fontWeight="300" lineHeight="1">
                {to_currency(sampleAmount)}
              </Typography>
            </Box>

            <Typography lineHeight="25px">
              4 payments of {to_currency(sampleAmount / 4)}.
            </Typography>
          </Flex>
        </Box>
      </Flex>
    </Box>
  )
}

const BetterWayToPay = ({ payIn4 }) => {
  return payIn4 ? <BetterWayToPayIn4 /> : <BetterWayToPayIn3 />
}

BetterWayToPay.propTypes = {
  payIn4: PropTypes.bool,
}

export default BetterWayToPay
